import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { AWARDS_API_PREFIX } from './awardsApiBase';

export interface ISubmitBidFeedbackParams {
  cycleId: string;
  applicantUserId: string;
  answers: Record<string, string>;
  awardTermsAccepted: boolean;
  /**
   * Optional provenance only — the server never keys the submission on it
   * (awards-service `http/api/feedback/dto.go`, ≤128 chars). The EOD chain
   * has the rated shift's job; the pending-feedback tab has none, because
   * pending rows collapse shared shifts (awards-service#37).
   */
  jobId?: string;
  /**
   * Overrides the `x-office` header for this submit. Pending-list rows must
   * be submitted as the ROW's office, which for a multi-office admin is not
   * the selected office — submitting without it records the wrong reviewer.
   */
  officeId?: string;
}

/**
 * Backend expects `answers`, `awardTermsAccepted`, and (optionally) `jobId`
 * as top-level body fields; `cycleId` and `applicantUserId` go in the URL
 * path. `direction` is server-derived — not sent.
 */
export const submitBidFeedback = async (params: ISubmitBidFeedbackParams): Promise<void> => {
  const { cycleId, applicantUserId, officeId, ...body } = params;
  const headers = await getAuthHeaders();
  await tempMeeApi.post(
    `${AWARDS_API_PREFIX}/cycles/${cycleId}/feedback/${applicantUserId}`,
    body,
    { headers: officeId ? { ...headers, 'x-office': officeId } : headers },
  );
};
